import UserContext from "global_state/context/UserContext"
import UserReducer from "global_state/reducer/UserReducer"
import { JSXElementConstructor, ReactElement, ReactFragment, ReactPortal, useReducer } from "react"
import { UserI } from "types/UserI"


const UserState = (props: { children: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined }) => {

    let user = {} as UserI
    if ("xf_active_user" in sessionStorage) {
        user = JSON.parse( sessionStorage.getItem('xf_active_user') || "") as UserI
    }
    // console.log("User State".toUpperCase(), user);
    // console.log(user);
    

    const init_state_user_context:UserI = {
        client_id: user?.client_id,
        connection_id: user?.connection_id,
        credits: user?.credits,
        first_name: user?.first_name,
        second_name: user?.second_name,
        phone: user?.phone,
        email: user?.email,
        membership: null,
        address: user?.address,
        birth_date: user?.birth_date
    }

    const [state, dispatch] = useReducer(UserReducer, init_state_user_context)

    return (
        <UserContext.Provider value={{user: state, dispatchUser: dispatch}}>
            {props.children}
        </UserContext.Provider>
    )
}

export default UserState